import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import 'dayjs/locale/pt'
import './dateTimePickerStyles.css'

const DatePickerInput = (props) => {

    const disableDates = (date) => {
        const d = new Date(date)

        return props.disabledDates.some(disabledDate => 
            d.getDate() === disabledDate.getDate() &&
            d.getMonth() === disabledDate.getMonth() &&
            d.getFullYear() === disabledDate.getFullYear()
        )
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='pt'>
            <DatePicker
                className={props.error ? 'myDateTimePickerError' : 'myDateTimePicker'}
                minDate={props.minDate}
                maxDate={props.maxDate}
                value={props.value}
                onChange={props.onChange}
                onAccept={props.onAccept}
                onError={props.onError}
                disablePast={true}
                disabled={props.disabled}
                shouldDisableDate={disableDates}
                format='DD/MM/YYYY'
                slotProps={{ textField: { size: 'small' } }}
            />
        </LocalizationProvider>
    )
}

export default DatePickerInput